import { Controller } from "@hotwired/stimulus"

// Drives the task resolution composer. Resolution chips are plain submit buttons:
// clicking one resolves the task immediately (the typed note rides along). This
// controller only handles the bits that need behavior:
//   • toggleSubmit — light the free-text "other" Submit once the note has text.
//   • validate — for buttons marked data-requires-notes (the Comment tool and the
//     free-text Submit), block submission until a note is present.
export default class extends Controller {
  static targets = ["notes", "submit"]

  connect() {
    this.toggleSubmit()
  }

  // Reflect whether the notes field has content onto the composer Submit button.
  toggleSubmit() {
    if (!this.hasSubmitTarget || !this.hasNotesTarget) return
    const hasText = this.notesTarget.value.trim().length > 0
    this.submitTargets.forEach((btn) => btn.classList.toggle("btn-primary-action", hasText))
  }

  validate(event) {
    const button = event.currentTarget
    if (button.dataset.requiresNotes !== "true") return

    if (this.hasNotesTarget && !this.notesTarget.value.trim()) {
      event.preventDefault()
      this.notesTarget.focus()
      this.notesTarget.classList.add("input-error")
      this.showError("Please provide a note for this action.")
    }
  }

  showError(message) {
    const group = this.element.querySelector("[data-requires-notes-group]") || this.element
    let errorMsg = group.querySelector(".notes-required-error")
    if (!errorMsg) {
      errorMsg = document.createElement("div")
      errorMsg.className = "notes-required-error text-error text-sm"
      group.appendChild(errorMsg)
    }
    errorMsg.textContent = message

    // Clear the error styling and message once the user starts typing.
    if (this.hasNotesTarget) {
      this.notesTarget.addEventListener("input", () => {
        this.notesTarget.classList.remove("input-error")
        errorMsg.remove()
      }, { once: true })
    }
  }
}
